// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mydocma-hint {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./projects/mydocma/dynamic-form/src/lib/hint-text/hint.component.scss","webpack://./../mydocma-dynamic-form-app%20(dev)/projects/mydocma/dynamic-form/src/lib/hint-text/hint.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ACCJ","sourcesContent":[".mydocma-hint{\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n    align-items: center;\r\n}\r\n",".mydocma-hint {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
